<template>
  <div
    class="thanks__page flex flex-col items-center justify-center"
  >
    <div
      class="thanks__page__container flex flex-col items-center justify-center relative"
    >
      <img
        class="thanks__page__container-img absolute"
        src="@/assets/images/thanks1.svg"
        alt="thanks"
      />
      <div
        class="text-white thanks__page__container__text flex items-center justify-center flex-col"
      >
        <h2 class="thanks__page__container__text--1 my-4 lg:my-8">Thanks !</h2>
        <h3 class="thanks__page__container__text--2">
          Your Attendance has been submitted successfully.
        </h3>
        <h5 class="my-2 md:my-4 thanks__page__container__text--3 text-center">
          Sign-up to discover your own hidden strengths and blind spots with
          GetBoarded. As an encouragement to take the first step with us, we
          offer a free infographic resume for you.
        </h5>
      </div>
      <a href="/user/dashboard" class="thanks__page__back-btn cursor-pointer"
        >Back to home</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
};
</script>

<style lang="scss" scoped>
.thanks__page {
  height: 100vh;
  // background-color: #121215;
  &__container {
    width: 33%;
    padding: 2em;
    background: linear-gradient(180deg, #f2c244 0%, #fff 40%);
    border-radius: 10px;
    &-img {
      top: 0%;
      transform: translate(0%, -50%);
    }
    &__text {
      &--1 {
        font-size: 4em;
        color: #f2c244;
        font-weight: 700;
      }
      &--2 {
        font-size: 2em;
        font-weight: 700;
        color: #101828;
      }
      &--3 {
        font-size: 1.2em;
        font-weight: 400;
        color: #667085;
      }
    }
  }
  &__back-btn {
    padding: 0.5em 1em;
    margin: 0.75em 0;
    background: #f2c244;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 5px;
    color: #ffffff;
    font-size: 1.25em;
    font-weight: bold;
  }
}

@media only screen and (max-width: 1300px) {
  .thanks__page {
    &__container {
      width: 50%;
    }
  }
}
@media only screen and (max-width: 991px) {
  .thanks__page {
    &__container {
      padding: 2em;
      padding-top: 4em;
      width: 70%;
      &__text {
        &--1 {
          font-size: 2.5em;
        }
        &--2 {
          font-size: 1.5em;
        }
      }
    }
    &__back-btn {
      margin-top: 1em;
    }
  }
}
@media only screen and (max-width: 600px) {
  .thanks__page {
    &__container {
      width: 90%;
      padding: 2em 1em;
      padding-bottom: 1em;
      &-img {
        width: 20%;
      }
      &__text {
        &--1 {
          font-size: 1.5em;
        }
        &--2 {
          font-size: 1em;
        }
        &--3 {
          font-size: 0.75em;
          color: #98a2b3;
        }
      }
    }
    &__back-btn {
      padding: 0.5em 1em;
      margin-top: 0.5em;
      font-size: 0.75em;
    }
  }
}
</style>
